export var LogLevel; (function (LogLevel) {
  const INFO = 0; LogLevel[LogLevel["INFO"] = INFO] = "INFO";
  const WARN = INFO + 1; LogLevel[LogLevel["WARN"] = WARN] = "WARN";
  const ERROR = WARN + 1; LogLevel[LogLevel["ERROR"] = ERROR] = "ERROR";
})(LogLevel || (LogLevel = {}));
